import request from '@/http'
const api6 = process.env.VUE_APP_APIMATERIALS
const api7 = process.env.VUE_APP_APIUSER
const api8 = process.env.VUE_APP_API
const urlSYNC = process.env.VUE_APP_SYNC
const urlLg = process.env.VUE_APP_LOGINAPI
const url = process.env.VUE_APP_LOGISTICS
export const apiHome = {
  //新的城市api
  getNewCityList: (params) => request.get(url + '/area/pinyinSearch', params),
  getSeach:(params) => request.post(`${urlLg}/recommand/v1/global/search`, params),
  getBanner: (params) => request.get(urlLg + '/jyb-advertisement/app/banner/getAdv',params), // 获取公共广告平台banner
  // 切换企业用户
  NewChangeCompany: (type,orgNo,) => request.put(urlLg + `/authentication/v1/user/${type}/${orgNo}/cut`,),
  getUserCompany: () => request.get(api7 + `/api/user/getUserCompany`,),

  getIdentifiers:() => request.get(`${urlLg}/authentication/sv1/user`),//用户权限
  getArea: () => request.get('/api/area/list'), // 地区
  fetchBannerList: () => request.get('/api/index/getBanner/PC'), // 首页banner图
  fetchTeamCategory: () => request.get('/api/index/getTeamCategory'), // 获取工队类目
  fetchRecommendedTalent: () => request.get('/api/index/getRecommendTalent'), // 获取推荐人才
  fetchRecommendTeam: () => request.get('/api/index/getRecommendTeam'), // 获取推荐工队
  getHotJobs: () => request.get('/api/index/getHotTalentRecruit'), // 获取热门职位
  getTheRecruitmentTeam: () => request.get('/api/teamRecruit/getNewList'), // 获取招工
  fetchRecommendCompany: () => request.get('/api/index/getRecommendCompany'), // 获取推荐企业
  getMenuList: () => request.get(process.env.VUE_APP_MENUURL), // 获取菜单
  getHotKey: () => request.get('/search/getHotkeys'),
  saveUserTokenToRedis: async function () {
    return new Promise((resolve, reject) => {
      request.get(urlSYNC + `/tokensync/saveUserTokenToRedis`, {}, {
        withCredentials: true
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 搜索企业
  searchEnterprise: (params) => request.get(api7 + '/userJoinCompanyAudit/searchComList', params), // 搜索企业
  // 邀请加盟
  InvitedForm: (params) => request.post(`${api8}` + '/ov1/member/league/inviteComJoin', params),

  // 获取意见反馈所属板块
  getPlate: async (data) => {
    return new Promise(async (resolve, reject) => {
      request.get(api6 + '/siteFeedback/plateSelect', data).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 提交反馈意见
  siteFeedback: async function (data) {
    return new Promise((resolve, reject) => {
      request.post(api6 + `/siteFeedback`, data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 地图-找工队
  searchTeamInfo: async function (data) {
    return new Promise((resolve, reject) => {
      request.post(`/api/index/searchTeamInfo`, data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 地图-找工程
  searchEngineer: async function (data) {
    return new Promise((resolve, reject) => {
      request.post(`/api/index/searchEngineer`, data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
